const NotFound =()=>{
    return(
        <div className="container d-flex align-items-center justify-content-center" style={{height:"85vh"}}>
        <h3 style={{color:"white", fontWeight:"bold",height:"100px",fontSize:"45px"}}>404 Not Found</h3>
        
        </div>
    )
}


export default NotFound;